export default __webpack_public_path__ + "static/media/D2H-ios-app.6e96135f.jpg";